import { combineReducers, Reducer } from 'redux';
import * as types from './page.types';
import { meetingsPageReducer } from './page-storage/meetingsOld/meetings.reducer';
import { usersPageReducer } from './page-storage/users/users.reducer';
import { tasksPageReducer } from './page-storage/tasks/tasks.reducer';
import { agendaItemsPageReducer } from './page-storage/agenda-items/agenda-items.reducer';
import { pageStateReducer } from './page-state/page-state.reducer';
import { kpiPageReducer } from './page-storage/kpi/kpi.reducer';
import { conclusionsPageReducer } from './page-storage/conclusions/conclusions.reducer';
import { sessionsPageReducer } from './page-storage/sessions/sessions.reducer';
import { notificationsPageReducer } from './page-storage/notifications/notifications.reducer';
import { templatesPageReducer } from './page-storage/templates/templates.reducer';
import { calendarsPageReducer } from './page-storage/calendars/calendars.reducer';
import { chartPageReducer } from './page-storage/chart/chart.reducer';
import { boardsPageReducer } from './page-storage/boards/boards.reducer';
import { boardListsPageReducer } from './page-storage/boardLists/boardLists.reducer';
import { labelsPageReducer } from './page-storage/labels/labels.reducer';
import { checkListsPageReducer } from './page-storage/checklists/checkLists.reducer';
import { activitiesPageReducer } from './page-storage/activities/activities.reducer';
import { userGroupsPageReducer } from './page-storage/user-groups/user-groups.reducer';
import { userSettingsPageReducer } from './page-storage/user-settings/user-settings.reducer';
import { passwordsPageReducer } from './page-storage/passwords/passwords.reducer';
import { passwordGroupsPageReducer } from './page-storage/password-groups/password-groups.reducer';
import { projectTasksPageReducer } from './page-storage/project-tasks/project-tasks.reducer';
import { projectTeamsPageReducer } from './page-storage/project-members/project-members.reducer';
import { projectsPageReducer } from './page-storage/projects/projects.reducer';
import { timerTrackerReducer } from './timer/timer.reducer';
import { accountProjectsPageReducer } from './page-storage/account-projects/account-projects.reducer';
import { projectTimesPageReducer } from './page-storage/project-times/project-times.reducer';
import { quartalsPageReducer } from './page-storage/quartals/quartals.reducer';
import { companyToolsCategoriesPageReducer } from './page-storage/company-tools-categories/company-tools-categories.reducer';
import { meetingsInfoPageReducer } from './page-storage/meetings-info/meetings-info.reducer';
import { meetingsSimplePageReducer } from './page-storage/meetings-simple/meetings-simple.reducer';
import { settingsPageReducer } from './settings/settings.reducer';
import { subscriptionPageReducer } from './subscription/subscription.reducer';
import { invoicesPageReducer } from './invoices/invoices.reducer';
import { tasksSimplePageReducer } from './page-storage/tasks-simple/tasks-simple.reducer';
import { meetingTasksPageReducer } from './page-storage/meeting-tasks/meeting-tasks.reducer';
import { meetingBoardsPageReducer } from './page-storage/meeting-boards/meeting-boards.reducer';
import { meetingFoldersPageReducer } from './page-storage/meeting-folder/meeting-folder.reducer';
import { meetingArchivesPageReducer } from './page-storage/meeting-archive/meeting-archive.reducer';
import { reportsPageReducer } from './page-storage/reports/reports.reducer';
import { sessionTranscriptPageReducer } from './session-transcript/transcripts.reducer';
import { personalNotesPageReducer } from './page-storage/personal-notes/personal-notes.reducer';

export const pageReducer: Reducer<types.IPageState, types.IPageAction> = combineReducers({
  meetingsSimple: meetingsSimplePageReducer,
  meetingBoards: meetingBoardsPageReducer,
  meetings: meetingsPageReducer,
  meetingFolders: meetingFoldersPageReducer,
  meetingArchives: meetingArchivesPageReducer,
  sessionTranscripts: sessionTranscriptPageReducer,
  users: usersPageReducer,
  tasks: tasksPageReducer,
  meetingTasks: meetingTasksPageReducer,
  reports: reportsPageReducer,
  tasksSimple: tasksSimplePageReducer,
  sessions: sessionsPageReducer,
  kpi: kpiPageReducer,
  agendaItems: agendaItemsPageReducer,
  conclusions: conclusionsPageReducer,
  notifications: notificationsPageReducer,
  templates: templatesPageReducer,
  calendars: calendarsPageReducer,
  chart: chartPageReducer,
  boards: boardsPageReducer,
  boardLists: boardListsPageReducer,
  labels: labelsPageReducer,
  checkLists: checkListsPageReducer,
  activities: activitiesPageReducer,
  userGroups: userGroupsPageReducer,
  userSettings: userSettingsPageReducer,
  passwords: passwordsPageReducer,
  passwordGroups: passwordGroupsPageReducer,
  projectTasks: projectTasksPageReducer,
  projectTeams: projectTeamsPageReducer,
  projects: projectsPageReducer,
  projectTimes: projectTimesPageReducer,
  accountProjects: accountProjectsPageReducer,
  pageState: pageStateReducer,
  timer: timerTrackerReducer,
  quartals: quartalsPageReducer,
  companyToolsCategories: companyToolsCategoriesPageReducer,
  meetingsInfo: meetingsInfoPageReducer,
  settings: settingsPageReducer,
  subscription: subscriptionPageReducer,
  invoices: invoicesPageReducer,
  personalNotes: personalNotesPageReducer,
});
